import React, { useEffect } from 'react';
import {
    Input,
    Form,
} from 'antd';

import './index.less';

const GSTTable = (props) => {
    let supgst = 0;
    let branchgst = 0;
    const { itemList, stateName, gst } = props;

    useEffect(() => {
        if (gst && stateName) {
            supgst = stateName.slice(0, 2);
            branchgst = gst.slice(0, 2);
        }
    }, [gst, stateName]);

    const renderGSTData = (itemList, gstValue) => {
        let totalCGST = 0;
        let totalSGST = 0;
        let totalIGST = 0;

        for (let item of itemList) {
            if (Number(item.gstRate) === gstValue * 2) {
                totalCGST += parseFloat(item.cgstAmount || 0);
                totalSGST += parseFloat(item.sgstAmount || 0);
                const lineIgst = parseFloat(item.igstAmount || 0);
                // Derive IGST from CGST+SGST when HSN only has split rates
                totalIGST += lineIgst > 0
                    ? lineIgst
                    : parseFloat(item.cgstAmount || 0) + parseFloat(item.sgstAmount || 0);
            }
        }

        totalCGST = totalCGST.toFixed(2);
        totalSGST = totalSGST.toFixed(2);
        totalIGST = totalIGST.toFixed(2);

        const customerState = stateName ? String(stateName).slice(0, 2) : "";
        const branchState = gst ? String(gst).slice(0, 2) : "";
        // Missing GSTIN → treat as local (CGST/SGST); both present & differ → IGST
        const isLocalState =
            !customerState || !branchState || customerState === branchState;

        return (
            <React.Fragment key={gstValue}>
                {isLocalState ? (
                    <>
                        <Form.Item
                            className="form-element"
                            label="CGST"
                            name={`cgst_${gstValue}`}
                        >
                            <div className="gst">
                                <span>{gstValue}%</span>
                                <Input
                                    style={{ marginLeft: "10px" }}
                                    placeholder="CGST"
                                    disabled={true}
                                    value={totalCGST}
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            className="form-element"
                            label="SGST"
                            name={`sgst_${gstValue}`}
                        >
                            <div className="gst">
                                <span>{gstValue}%</span>
                                <Input
                                    style={{ marginLeft: "10px" }}
                                    disabled={true}
                                    placeholder="SGST"
                                    value={totalSGST}
                                />
                            </div>
                        </Form.Item>
                    </>
                ) : (
                    <Form.Item
                        className="form-element"
                        label="IGST"
                        name={`igst_${gstValue}`}
                    >
                        <div className="gst">
                            <span>{gstValue * 2}%</span>
                            <Input
                                style={{ marginLeft: "10px" }}
                                disabled={true}
                                placeholder="IGST"
                                value={totalIGST}
                            />
                        </div>
                    </Form.Item>
                )}
            </React.Fragment>
        );
    };

    const uniqueGstRates = Array.from(
        new Set(
            (itemList || [])
                .map((item) => Number(item.gstRate))
                .filter((rate) => rate > 0 && !isNaN(rate))
        )
    ).sort((a, b) => b - a);

    return (
        <div>
            {uniqueGstRates.map((gstRate) => renderGSTData(itemList || [], gstRate / 2))}
        </div>
    );
};

export default GSTTable;